var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22488 38.416H8.96667H10.552L10.7082 36.8384C12.2872 20.89 25.7435 8.41602 42.1 8.41602C59.5657 8.41602 73.7167 22.6314 73.7167 39.9994C73.7167 57.3673 59.5657 71.5827 42.1 71.5827C31.5919 71.5827 22.3254 66.4162 16.5679 58.4574L19.0614 56.4848C24.2086 63.6949 32.5969 68.416 42.1333 68.416C49.6699 68.416 56.8978 65.4221 62.227 60.093C67.5561 54.7638 70.55 47.5359 70.55 39.9994C70.55 32.4628 67.5561 25.2349 62.227 19.9057C56.8978 14.5766 49.6699 11.5827 42.1333 11.5827C27.6369 11.5827 15.704 22.4538 13.9634 36.45L13.7189 38.416H15.7H20.6671L12.435 46.6261L4.22488 38.416ZM50.2167 34.1327V35.848L51.9317 35.8823C52.6785 35.8973 53.25 36.4847 53.25 37.1994V52.566C53.25 53.2786 52.6545 53.8827 51.9333 53.8827H33.5C32.7788 53.8827 32.1833 53.2786 32.1833 52.566V37.1994C32.1833 36.4847 32.7548 35.8973 33.5017 35.8823L35.2167 35.848V34.1327V30.766C35.2167 26.6366 38.5957 23.2827 42.7 23.2827C46.8417 23.2827 50.2167 26.6407 50.2167 30.766V34.1327ZM36.3833 34.1327V35.8827H38.1333H47.3H49.05V34.1327V30.766C49.05 27.2496 46.1832 24.4494 42.7 24.4494C39.2418 24.4494 36.3833 27.2579 36.3833 30.766V34.1327Z",
    stroke: "#E96012",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReset);
export default __webpack_public_path__ + "static/media/ic_reset.b3cf5432364c88f52921bfcdf0a96947.svg";
export { ForwardRef as ReactComponent };